// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nhot","controls":"styles_controls__Qg1kM","charLimit":"styles_charLimit__1KcVM","input":"styles_input__2I8Bv","send":"styles_send__3bH_B"};